"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = require("./constants");

var _designLanguage = require("@doordash/design-language");

var _utilities = require("@doordash/utilities");

var React = _interopRequireWildcard(require("react"));

var _styles = require("./styles");

var _TagTypes = require("./types/TagTypes");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var renderTagIcon = function renderTagIcon(_ref) {
  var accessibilityLabel = _ref.accessibilityLabel,
      iconType = _ref.iconType,
      onClick = _ref.onClick,
      size = _ref.size,
      type = _ref.type;

  if (onClick) {
    return /*#__PURE__*/React.createElement(_styles.IconButtonWrapper, {
      "aria-label": accessibilityLabel,
      onClick: onClick,
      size: size
    }, /*#__PURE__*/React.createElement(_designLanguage.Icon, {
      color: _designLanguage.Icon.Colors["Tag".concat(type, "Icon")],
      size: _designLanguage.Icon.Sizes.Small,
      type: _designLanguage.Icon.Types[iconType]
    }));
  }

  return /*#__PURE__*/React.createElement(_styles.IconWrapper, {
    size: size
  }, /*#__PURE__*/React.createElement(_designLanguage.Icon, {
    color: _designLanguage.Icon.Colors["Tag".concat(type, "Icon")],
    size: _designLanguage.Icon.Sizes.Small,
    type: _designLanguage.Icon.Types[iconType]
  }));
};

var Tag = function Tag(_ref2) {
  var text = _ref2.text,
      type = _ref2.type,
      size = _ref2.size,
      hasLeadingIcon = _ref2.hasLeadingIcon,
      hasTrailingIcon = _ref2.hasTrailingIcon,
      leadingIconAccessibilityLabel = _ref2.leadingIconAccessibilityLabel,
      leadingIconType = _ref2.leadingIconType,
      onLeadingClick = _ref2.onLeadingClick,
      onTrailingClick = _ref2.onTrailingClick,
      textProps = _ref2.textProps,
      trailingIconAccessibilityLabel = _ref2.trailingIconAccessibilityLabel,
      trailingIconType = _ref2.trailingIconType,
      props = _objectWithoutProperties(_ref2, ["text", "type", "size", "hasLeadingIcon", "hasTrailingIcon", "leadingIconAccessibilityLabel", "leadingIconType", "onLeadingClick", "onTrailingClick", "textProps", "trailingIconAccessibilityLabel", "trailingIconType"]);

  if (hasLeadingIcon && typeof onLeadingClick !== 'undefined' && !leadingIconAccessibilityLabel) {
    throw new Error('You MUST define leadingIconAccessibilityLabel if you are passing a callback to onLeadingClick');
  }

  if (hasTrailingIcon && typeof onTrailingClick !== 'undefined' && !trailingIconAccessibilityLabel) {
    throw new Error('You MUST define trailingIconAccessibilityLabel if you are passing a callback to onTrailingClick');
  }

  var propsToForward = (0, _utilities.getPropsToForward)({
    props: props,
    prefixesToForward: ['data-', 'aria-']
  });
  return /*#__PURE__*/React.createElement(_styles.TagWrapper, _extends({
    backgroundColor: "Tag".concat(type, "Background"),
    hasLeadingIcon: hasLeadingIcon,
    hasTrailingIcon: hasTrailingIcon,
    size: size
  }, propsToForward), /*#__PURE__*/React.createElement(_designLanguage.InlineChildren, {
    alignItems: _designLanguage.InlineChildren.Alignment.Center,
    justifyContent: _designLanguage.InlineChildren.Justification.Center,
    size: _designLanguage.InlineChildren.Sizes[_constants.sizeStyles[size].inlineChildrenSize]
  }, hasLeadingIcon && renderTagIcon({
    accessibilityLabel: leadingIconAccessibilityLabel,
    iconType: leadingIconType || _constants.defaultIconTypes[type],
    onClick: onLeadingClick,
    size: size,
    type: type
  }), /*#__PURE__*/React.createElement(_designLanguage.Text, _extends({
    color: _designLanguage.Text.Colors["Tag".concat(type, "Foreground")],
    styles: _designLanguage.Text.Styles[_constants.tagTextStyles[size]],
    overflow: _designLanguage.Text.Overflows.Truncate
  }, textProps), text), hasTrailingIcon && renderTagIcon({
    accessibilityLabel: trailingIconAccessibilityLabel,
    iconType: trailingIconType || _constants.defaultIconTypes[type],
    onClick: onTrailingClick,
    size: size,
    type: type
  })));
};

Tag.Sizes = _TagTypes.TagSizes;
Tag.Types = _TagTypes.TagTypes;
Tag.IconTypes = _TagTypes.IconTypes;
Tag.defaultProps = {
  hasLeadingIcon: false,
  hasTrailingIcon: false,
  size: Tag.Sizes.Small,
  type: Tag.Types.InformationalDefault
};
var _default = Tag;
exports["default"] = _default;